import React from "react";
import { Tab, Segment, Header } from "semantic-ui-react";
import { translate } from "react-i18next";
import RoomsContainer from "../rooms/RoomsList";
import UsersList from "../users/UsersList";
import Preview from "../synchronization/Preview";
import RoomGroupList from "../rooms/groups/RoomGroupsList";
const SettingsComponent = props => {
  const panes = [
    {
      menuItem: props.t("room:roomTypesText"),
      render: () => (
        <Tab.Pane>
          <RoomGroupList />
        </Tab.Pane>
      )
    },
    {
      menuItem: props.t("room:roomsText"),
      render: () => (
        <Tab.Pane>
          <RoomsContainer />
        </Tab.Pane>
      )
    },
    {
      menuItem: props.t("user:usersText"),
      render: () => (
        <Tab.Pane>
          <UsersList />
        </Tab.Pane>
      )
    },
    {
      menuItem: props.t("synchronization:synchronizationText"),
      render: () => (
        <Tab.Pane>
          <Preview />
        </Tab.Pane>
      )
    }
  ];
  return (
    <React.Fragment>
      <Header as="h1" content={props.t("sidebar:settings")} />
      <Tab panes={panes} />
    </React.Fragment>
  );
};

export default translate("translations")(SettingsComponent);



// WEBPACK FOOTER //
// ./src/components/SettingsComponent.js